<script>
    import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();
    
    let action = () => {
        dispatch('mousedown');
    };

    let icon = '';
    let restingIcon = 'fa fa-sort';

    export let active = false;
    export let sortType = 'resting'

    $:{
        if(active == false){
            icon = restingIcon;
        }
        else{
            sortType;
            switch(sortType){
                case 'resting':
                    icon = 'fa fa-dash';
                    break;
                case 'ascending':
                    icon = 'fa fa-caret-down';
                    break;
                case 'descending':
                    icon = 'fa fa-caret-up';
                    break;
            }
        }
    }
</script>

<th class="pointer" on:mousedown={action}>
    <slot></slot>
    <i class="{icon}"></i>
</th>

<style>
    .pointer {
        cursor: pointer;
    }

    th{
        font-size: 0.9em;
    }
</style>